import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ErrorPopup.module.css";

export const ErrorPopup = () => {
  const [show, setShow] = React.useState(true);
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <h2>Oops! Something went wrong.</h2>
        <p>We couldn't save your data. Please try again.</p>
        <div className={styles.buttonGroup}>
          <button onClick={() => setShow(false)}>Cancel</button>
          <button onClick={() => navigate("/")}>Back Home</button>
        </div>
      </div>
    </div>
  );
};
